module.exports = [
  { // Gender
    question: {
      label: 'What is your gender, from birth?',
      prompt: 'gender'
    }, 
    input: 'radio',
    options: [
      { label: 'Male', value: 'male' },
      { label: 'Female', value: 'female' },
    ]
  },
  { // Age
    question: {
      label: 'How old are you?',
      prompt: 'age'
    }, 
    input: 'radio',
    options: [
      { label: '35 or younger', value: '35 or younger' },
      { label: '36-50', value: '36-50' },
      { label: '51-65', value: '51-65' },
      { label: '66-80', value: '66-80' },
      { label: '81 or older', value: '81 or older' }
    ]
  },
  { // Total Shoulder Arthroplasty
    question: {
      label: 'Have you had a total shoulder arthroplasty?',
      prompt: 'shoulder_arthroplasty'
    }, 
    input: 'radio',
    options: [
      { label: 'Yes', value: 'yes' },
      { label: 'No', value: 'no' },
    ]
  },
  { // Pain
    question: {
      label: 'What level of pain are you feeling right now?',
      prompt: 'pain'
    },
    input: 'slider'
  },
  { // Past Treatments
    question: {
      label: `Mark any treatments you've had`,
      prompt: 'past_treatments'
    }, 
    input: 'checkbox',
    options: [
      { label: 'Injection', value: 'injection' },
      { label: 'Physical Therapy', value: 'pt' },
      { label: 'Imaging (x-ray, MRI)', value: 'imaging' },
      { label: 'Surgery', value: 'surgery' },
      { label: 'None of the Above', value: 'none' },
    ]
  },
  { // Past Visits
    question: {
      label: `Have you had an evaluation by medical personnel?`,
      prompt: 'past_visits'
    }, 
    input: 'checkbox',
    options: [
      { label: 'Primary Care', value: 'primary' },
      { label: 'Orthopedic', value: 'orthropedic' },
      { label: 'Emergency Care', value: 'er' },
      { label: 'Chiropractor', value: 'chiropractor' },
      { label: 'None', value: 'none' },
    ]
  },
  { // Pain Description
    question: {
      label: 'Describe your pain',
      prompt: 'pain_description'
    }, 
    input: 'radio',
    options: [
      { label: 'None', value: 'none' },
      { label: 'Chronic', value: 'chronic' },
      { label: 'Acute', value: 'acute' },
      { label: 'Intermittent', value: 'intermittent' }
    ]
  },
  { // Cause
    question: {
      label: 'Is this condition a result of:',
      prompt: 'cause'
    }, 
    input: 'radio',
    options: [
      { label: 'Accident or Sports Injury', value: 'sports_injury' },
      { label: 'Progressive Arthritis/Tendonitis', value: 'arthritis_tendonitis' },
      { label: 'Not Sure', value: 'unknown' },
    ]
  },
  { // Swelling
    question: {
      label: 'Describe your swelling',
      prompt: 'swelling'
    }, 
    input: 'radio',
    options: [
      { label: 'None', value: 'none' },
      { label: 'Moderate', value: 'moderate' },
      { label: 'Severe', value: 'severe' },
    ]
  },
  { // Issues Lifting/Carrying
    question: {
      label: 'Do you have any issues lifting or carrying objects?',
      prompt: 'issues_lifting'
    }, 
    input: 'radio',
    options: [
      { label: 'Yes', value: 'yes' },
      { label: 'No', value: 'no' },
    ]
  },
  { // Flexibility
    question: {
      label: 'How is the flexibility or range of motion in your affected shoulder',
      prompt: 'rom_flexibility'
    }, 
    input: 'radio',
    options: [
      { label: 'Painful or Unable to Perform', value: 'painful_or_unable' },
      { label: 'Limited', value: 'limited' },
      { label: 'Normal', value: 'normal' },
    ]
  },
  { // Popping/Snapping
    question: {
      label: 'Have you felt a pop or snap within the affected joint?',
      prompt: 'popping_snapping_catching'
    }, 
    input: 'radio',
    options: [
      { label: 'Yes', value: 'yes' },
      { label: 'No', value: 'no' },
    ]
  },
  { // Grinding/Catching While Walking
    question: {
      label: 'Any sense of grinding or catching inside the joint when bending?',
      prompt: 'grinding'
    }, 
    input: 'radio',
    options: [
      { label: 'Yes', value: 'yes' },
      { label: 'No', value: 'no' },
    ]
  },

  { // Issues with Arms Overhead
    question: {
      label: 'Do you have any issues lifting your arms over your head?',
      prompt: 'lifting_arms'
    }, 
    input: 'radio',
    options: [
      { label: 'Yes', value: 'yes' },
      { label: 'No', value: 'no' },
    ]
  },
  { // Arms behind back
    question: {
      label: 'Do you have any issues lifting your arms behind your back?',
      prompt: 'arms_behind_back'
    }, 
    input: 'radio',
    options: [
      { label: 'Yes', value: 'yes' },
      { label: 'No', value: 'no' },
    ]
  },
  { // Sleeping issues
    question: {
      label: 'Do you have a hard time sleeping?',
      prompt: 'sleeping_issues'
    }, 
    input: 'radio',
    options: [
      { label: 'Yes', value: 'yes' },
      { label: 'No', value: 'no' },
    ]
  },
  { // Pain Increasing
    question: {
      label: 'Is your pain made worse due to activity, and getting progressively worse?',
      prompt: 'pain_increasing'
    }, 
    input: 'radio',
    options: [
      { label: 'Yes', value: 'yes' },
      { label: 'No', value: 'no' },
    ]
  },
  { // Pain Location
    question: {
      label: 'Where is your shoulder pain located?',
      prompt: 'pain_location'
    }, 
    input: 'radio',
    options: [
      { label: 'Front/Chest', value: 'front_chest' },
      { label: 'Side/Flank', value: 'side_flank' },
      { label: 'Back/Shoulder Blade', value: 'back_shoulder' },
      { label: 'All of the Above', value: 'all' },
    ]
  },
]